import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import Cookies from "js-cookie";
import API_ENDPOINTS from "../config/api";

// 고유 ID 생성 함수
const encodeUUID = () => {
  const randomPart = Math.random().toString(36).substring(2, 10);
  const timestampPart = Date.now().toString(36);
  return `${randomPart}${timestampPart}`;
};

const PaymentCreditCardPage = () => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [isChecked, setIsChecked] = useState(false);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [totalAmount, setTotalAmount] = useState(10000);

  // IMP 스크립트 로드
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.iamport.kr/v1/iamport.js";
    script.async = true;
    script.onload = () => {
      if (window.IMP) {
        window.IMP.init("imp60665034"); // 가맹점 식별코드
      }
    };
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // 결제 금액 계산 (본인 포함 인원수 × 10000원)
  useEffect(() => {
    const applicationType = Cookies.get("applicationType");

    // 대표신청자인 경우 공동신청자 수를 고려하여 계산
    if (applicationType === "representative") {
      const totalApplicants = parseInt(
        Cookies.get("totalApplicants") || "1",
        10
      );
      const calculatedAmount = totalApplicants * 10000;
      setTotalAmount(calculatedAmount);
      Cookies.set("lawsuit_amount", calculatedAmount, {
        expires: 7,
        path: "/",
      });
    } else {
      // 본인 신청인 경우 1명만
      setTotalAmount(10000);
      Cookies.set("lawsuit_amount", 10000, {
        expires: 7,
        path: "/",
      });
    }
  }, []);

  // 사용자 정보 가져오기
  useEffect(() => {
    const fetchUserData = async () => {
      setIsLoading(true);
      try {
        const token = Cookies.get(
          API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN
        );

        if (!token) {
          throw new Error("인증 토큰이 없습니다. 다시 로그인해주세요.");
        }

        const response = await fetch(`${API_ENDPOINTS.BASE_URL}/clients/me`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("사용자 정보를 가져오는데 실패했습니다.");
        }

        const data = await response.json();
        setUserData(data);
      } catch (err) {
        setError(err.message || "사용자 정보를 가져오는데 실패했습니다.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // 뒤로 가기
  const handleBack = () => {
    navigate(-1);
  };

  // 결제 완료 API 호출
  // const completePayment = async (paymentId) => {
  //   try {
  //     const token = Cookies.get(API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN);
  //     if (!token) {
  //       throw new Error("인증 토큰이 없습니다.");
  //     }

  //     const applicationNumber = Cookies.get("application_number");
  //     if (!applicationNumber) {
  //       throw new Error("신청번호가 없습니다.");
  //     }

  //     const response = await fetch(
  //       `${API_ENDPOINTS.BASE_URL}/payments/complete`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify({
  //           paymentId: paymentId,
  //           applicationNumber: applicationNumber,
  //           price: lawsuitAmount,
  //         }),
  //       }
  //     );

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       throw new Error(errorData.message || "결제 완료 처리에 실패했습니다.");
  //     }

  //     return await response.json();
  //   } catch (error) {
  //     // 결제 취소 시도
  //     const cancelSuccess = await cancelPayment(paymentId);

  //     if (cancelSuccess) {
  //     } else {
  //       Object.keys(Cookies.get()).forEach((cookie) => {
  //         Cookies.remove(cookie);
  //       });
  //       // 결제는 성공했으나 취소 실패했으므로 완료 페이지로 이동
  //       navigate("/complete");
  //     }
  //     throw error;
  //   }
  // };

  // 결제 취소 API 호출
  // const cancelPayment = async (
  //   paymentId,
  //   reason = "결제 완료 처리 실패로 인한 취소"
  // ) => {
  //   try {
  //     const token = Cookies.get(API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN);
  //     if (!token) {
  //       throw new Error("인증 토큰이 없습니다.");
  //     }

  //     const response = await fetch(
  //       `${API_ENDPOINTS.BASE_URL}/payments/cancel`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify({
  //           paymentId: paymentId,
  //           reason: reason,
  //         }),
  //       }
  //     );

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       return false;
  //     }

  //     return true;
  //   } catch (error) {
  //     return false;
  //   }
  // };

  // 애니메이션 변수
  const pageVariants = {
    initial: {
      opacity: 0,
    },
    in: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
    out: {
      opacity: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  const contentVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    in: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delay: 0.2,
        staggerChildren: 0.1,
      },
    },
  };

  const processPayment = async () => {
    if (!isChecked) {
      return;
    }

    if (!userData) {
      return;
    }

    if (!window.IMP) {
      alert("결제 모듈을 불러오는 중입니다. 잠시 후 다시 시도해주세요.");
      return;
    }

    try {
      setIsPaymentProcessing(true);
      const applicationNumber = Cookies.get("application_number");
      const paymentId = `pay_${encodeUUID()}`;

      // 모바일 환경인지 확인
      const isMobile = !isDesktop;
      const PORTONE_STORE_ID = "store-c0cd2b2d-8f6e-4586-89d3-b545b2a73a8f";

      // KG이니시스 결제 파라미터
      const paymentParams = {
        channelKey: "channel-key-18fdaec6-3dc0-450e-90a4-96a3be932f66",
        pay_method: "card",
        merchant_uid: paymentId,
        name: "쿠팡 집단소송 접수비",
        amount: totalAmount,
        buyer_email: userData.email || "user@example.com",
        buyer_name: userData.name || "사용자",
        buyer_tel: userData.phoneNumber || "010-1234-5678",
        buyer_addr: userData.address || "서울특별시",
        custom_data: {
          applicationNumber: applicationNumber,
          price: totalAmount,
        },
        // m_redirect_url: `https://class-action-portal-dev.vercel.app/payment-verification?paymentId=${paymentId}`,
        // m_redirect_url: `https://172.30.1.33:3000/payment-verification?paymentId=${paymentId}`,
        notice_url: "https://lawsuit.aitheh.com/payments/complete",
      };

      // 모바일 환경에서는 리디렉션 URL 설정
      if (isMobile) {
        paymentParams.m_redirect_url =
          "https://www.lawfirmthe-h-coupang.info/payment-verification";
        // paymentParams.m_redirect_url = `http://172.30.1.33:3000/payment-verification`;
        // 모바일 간편결제 제외 설정
        paymentParams.bypass = {
          P_RESERVED: "noeasypay=Y",
        };
      } else {
        // PC 환경 간편결제 제외 설정
        paymentParams.bypass = {
          acceptmethod: "noeasypay",
        };
        // PC 환경 할부 개월 수 설정 (5만원 이상일 때만 할부 가능)
        // if (lawsuitAmount >= 50000) {
        //   paymentParams.display = {
        //     card_quota: [2, 3, 4, 5, 6], // 2~6개월 할부 가능
        //   };
        // } else {
        //   paymentParams.display = {
        //     card_quota: [], // 일시불만 가능
        //   };
        // }
      }

      // KG이니시스 결제창 호출
      window.IMP.request_pay(paymentParams, async (rsp) => {
        if (rsp.success) {
          // 결제 성공
          try {
            // 결제 완료 API 호출
            // await completePayment(rsp.merchant_uid);

            // 결제 성공 - 쿠키는 유지하고 결제 확인 페이지에서 처리되도록 함
            // 모바일에서는 m_redirect_url로 자동 리다이렉트됨
            // PC에서는 수동으로 리다이렉트
            if (!isMobile) {
              navigate(`/payment-verification?imp_uid=${rsp.merchant_uid}`);
            }
          } catch (completeError) {
            console.error("결제 완료 처리 실패:", completeError);
            alert(
              "결제는 완료되었으나 처리 중 오류가 발생했습니다. 고객센터로 문의해주세요."
            );
          }
        } else {
          // 결제 실패
          console.error("결제 실패:", rsp.error_msg);
          alert(`결제에 실패했습니다: ${rsp.error_msg}`);
        }
        setIsPaymentProcessing(false);
      });
    } catch (error) {
      console.error("결제 처리 중 오류:", error);
      alert("결제 처리 중 오류가 발생했습니다. 다시 시도해주세요.");
      setIsPaymentProcessing(false);
    }
  };

  // 로딩 표시
  if (isLoading) {
    return (
      <PageBackground>
        <Container>
          <Header>
            <BackButton onClick={handleBack}>
              <BackIcon>&#10094;</BackIcon>
            </BackButton>
            <HeaderTitle>카드 결제</HeaderTitle>
          </Header>
          <Content>
            <LoadingContainer>
              <Spinner />
              <LoadingMessage>
                사용자 정보를 불러오는 중입니다...
              </LoadingMessage>
            </LoadingContainer>
          </Content>
        </Container>
      </PageBackground>
    );
  }

  // 에러 표시
  if (error) {
    return (
      <PageBackground>
        <Container>
          <Header>
            <BackButton onClick={handleBack}>
              <BackIcon>&#10094;</BackIcon>
            </BackButton>
            <HeaderTitle>카드 결제</HeaderTitle>
          </Header>
          <Content>
            <ErrorContainer>
              <ErrorIcon>⚠️</ErrorIcon>
              <ErrorTitle>오류가 발생했습니다</ErrorTitle>
              <ErrorDescription>{error}</ErrorDescription>
              <RetryButton onClick={() => window.location.reload()}>
                다시 시도하기
              </RetryButton>
            </ErrorContainer>
          </Content>
        </Container>
      </PageBackground>
    );
  }

  return (
    <PageBackground>
      <Container
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        <Header>
          <BackButton onClick={handleBack}>
            <BackIcon>&#10094;</BackIcon>
          </BackButton>
          <HeaderTitle>카드 결제</HeaderTitle>
        </Header>
        <Content variants={contentVariants} initial="initial" animate="in">
          <ContentSection>
            <PageHeader>신용카드 결제</PageHeader>
            <TitleWithIcon>
              <PayIcon src="/png/creditcardIcon.png" alt="신용카드 아이콘" />
              <SectionTitle>결제하기</SectionTitle>
            </TitleWithIcon>
            <SectionSubtitle>
              소송 접수를 위한 비용을 신용카드로 결제해주세요
            </SectionSubtitle>

            {userData && (
              <UserInfoBox>
                <BoxTitle>결제자 정보</BoxTitle>
                <DetailRow>
                  <DetailLabel>이름</DetailLabel>
                  <DetailValue>{userData.name}</DetailValue>
                </DetailRow>
                <DetailRow>
                  <DetailLabel>연락처</DetailLabel>
                  <DetailValue>{userData.phoneNumber}</DetailValue>
                </DetailRow>
                <DetailRow>
                  <DetailLabel>이메일</DetailLabel>
                  <DetailValue>{userData.email}</DetailValue>
                </DetailRow>
              </UserInfoBox>
            )}

            <PaymentDetailsBox>
              <BoxTitle>결제 금액 상세</BoxTitle>
              <Divider />
              <TotalRow>
                <TotalLabel>총 결제 금액</TotalLabel>
                <TotalValue>{totalAmount.toLocaleString()}원</TotalValue>
              </TotalRow>
            </PaymentDetailsBox>

            <CreditCardInfoBox>
              <BoxTitle>카드 결제 안내</BoxTitle>
              <CardInfoItem>
                • 모든 신용카드 및 체크카드 결제가 가능합니다.
              </CardInfoItem>
              <CardInfoItem>
                • 결제 시 카드사 인증 과정이 진행됩니다.
              </CardInfoItem>
              <CardInfoItem>
                • 일부 카드사의 경우 무이자 할부가 가능합니다.
              </CardInfoItem>
              <CardInfoItem>• 법인카드도 결제 가능합니다.</CardInfoItem>
            </CreditCardInfoBox>

            <TermsSection>
              <TermsTitle>환불 규정 및 주의사항</TermsTitle>
              <TermsList>
                <TermsItem>
                  <strong>1. 서비스 제공 기간</strong>
                  <br /> - 2025년 4월 30일부터 2026년 4월 30일까지
                </TermsItem>
                <TermsItem>
                  <strong>2. 교환/환불 정책</strong>
                  <br />
                  본 결제는 법무법인과의 집단소송 수임계약 체결을 위한
                  법률서비스 비용에 해당합니다.
                  <br />
                  <br />
                  결제 완료와 동시에 수임계약이 성립되며, 전자서명 또는 약관
                  동의 절차를 통해 법률 대리권이 위임됩니다.
                  <br />
                  <br />
                  특성상 계약 체결 이후에는 단순 변심, 착오 등의 사유로 환불이나
                  교환이 불가능합니다.
                </TermsItem>
                <TermsItem>
                  <strong>3. 취소 및 철회 규정</strong>
                  <br />
                  집단소송 참여자는 원할 경우, 소송 진행 도중 고소 취하(소송
                  철회)를 요청할 수 있습니다.
                  <br />
                  <br />
                  단, 고소 취하 여부와 관계없이, 이미 결제된 수임료, 행정 처리
                  비용, 전자서명 비용 등은 환급되지 않으며, 이는 사건 처리
                  준비가 시작됨과 동시에 소요되기 때문입니다.
                  <br />
                  <br />
                  또한 소송 취하 시, 기존 법률적 보호 범위에서 제외될 수 있으며,
                  별도의 절차가 필요할 수 있습니다.
                </TermsItem>
              </TermsList>

              <CheckboxContainer onClick={() => setIsChecked(!isChecked)}>
                <Checkbox checked={isChecked}>
                  {isChecked ? (
                    <CheckedImg src="/png/checked.png" alt="체크박스" />
                  ) : (
                    <CheckedImg src="/png/checkedinActive.png" alt="체크박스" />
                  )}
                </Checkbox>
                <CheckboxLabel>
                  상기 내용을 모두 확인하였으며 동의합니다.
                </CheckboxLabel>
              </CheckboxContainer>
            </TermsSection>

            <ButtonContainer>
              <PaymentButton
                onClick={processPayment}
                disabled={!isChecked || isPaymentProcessing}
              >
                {isPaymentProcessing ? "결제 처리 중..." : "카드로 결제하기"}
              </PaymentButton>
            </ButtonContainer>
            <div style={{ height: "80px" }} />
          </ContentSection>
        </Content>
      </Container>
    </PageBackground>
  );
};

// 스타일 컴포넌트
const PageBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  background-color: #f8f8f8;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (min-width: 769px) {
    padding: 40px 20px 60px;
    background-color: #fff;
  }
`;

const Container = styled(motion.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #f8f8f8;

  /* 모바일 디바이스 */
  @media (max-width: 768px) {
    min-height: auto;
    box-shadow: none;
    padding: 0 0 80px 0;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
  }

  /* 데스크탑 디바이스 */
  @media (min-width: 769px) {
    border-radius: 20px;
    min-height: auto;
    max-height: none;
    max-width: 470px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    padding: 20px;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 16px 0;
  text-align: center;
  position: relative;
  border-bottom: 1px solid #eee;
`;

const BackButton = styled.button`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BackIcon = styled.span`
  font-size: 20px;
  color: #333;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
`;

const ContentSection = styled.div`
  width: 100%;
  max-width: 500px;
`;

const PageHeader = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0 0 30px 0;
  display: none;
`;

const TitleWithIcon = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
`;

const PayIcon = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`;

const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0;
`;

const SectionSubtitle = styled.p`
  font-size: 16px;
  color: #666;
  margin: 8px 0 24px 0;
`;

const UserInfoBox = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
`;

const BoxTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
  color: #333;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const DetailLabel = styled.span`
  color: #666;
`;

const DetailValue = styled.span`
  font-weight: 500;
  color: #333;
`;

const PaymentDetailsBox = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
`;

const CreditCardInfoBox = styled.div`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
`;

const CardInfoItem = styled.p`
  font-size: 14px;
  color: #666;
  margin: 8px 0;
  line-height: 1.5;
`;

const Divider = styled.div`
  height: 1px;
  background-color: #eee;
  margin: 15px 0;
`;

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const TotalLabel = styled.span`
  font-weight: 600;
  color: #333;
`;

const TotalValue = styled.span`
  font-weight: 700;
  font-size: 18px;
  color: #333;
`;

const TermsSection = styled.div`
  margin-bottom: 24px;
`;

const TermsTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 15px 0;
  color: #333;
`;

const TermsList = styled.div`
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
`;

const TermsItem = styled.p`
  font-size: 14px;
  color: #555;
  margin: 8px 0;
  line-height: 1.5;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 0;
`;

const Checkbox = styled.div`
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const CheckedImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const CheckboxLabel = styled.span`
  font-size: 14px;
  margin-left: 10px;
  color: #333;
  font-weight: 500;
`;

const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 20px;
`;

const PaymentButton = styled.button`
  display: flex;
  width: 100%;
  height: 56px;
  padding: 0px 14px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: ${(props) => (props.disabled ? "#ccc" : "#0075ff")};
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: none;
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};
  transition: background-color 0.2s;
`;

// 로딩 관련 컴포넌트
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  width: 100%;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 117, 255, 0.1);
  border-radius: 50%;
  border-left-color: #0075ff;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadingMessage = styled.p`
  font-size: 16px;
  color: #666;
  text-align: center;
`;

// 에러 관련 컴포넌트
const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  width: 100%;
  text-align: center;
`;

const ErrorIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

const ErrorTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
`;

const ErrorDescription = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0 0 24px 0;
`;

const RetryButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  background-color: #0075ff;
  color: white;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
`;

export default PaymentCreditCardPage;
